import React, { useRef, useState } from "react";
import { Box, Typography, Tabs, Tab } from "@mui/material";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import FullscreenVideoPopup from "./FullscreenVideoPopup";

const TAB_FILTERS = [
  { value: "all", label: "All" },
  { value: "thei", label: "THEI" },
  { value: "school", label: "學校活動" },
  { value: "industry", label: "合作機構" },
];

const VideoThumbCard = ({ item, onPlay }) => {
  return (
    <Box
      onClick={() => onPlay(item.video_url)}
      sx={{
        flexShrink: 0,
        width: 200,
        cursor: "pointer",
        borderRadius: 0,
        overflow: "hidden",
        bgcolor: "rgba(0,0,0,0.5)",
        "&:hover .play-icon": { opacity: 1 },
        "&:hover img": { opacity: 0.7 },
      }}
    >
      <Box sx={{ position: "relative" }}>
        <Box
          component="img"
          src={`${item.thumbnail}`}
          alt={item.caption}
          sx={{
            width: "100%",
            height: 120,
            objectFit: "cover",
            display: "block",
            transition: "opacity 0.2s",
          }}
        />
        <Box
          className="play-icon"
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: 0.6,
            transition: "opacity 0.2s",
          }}
        >
          <PlayCircleOutlineIcon sx={{ fontSize: 48, color: "white" }} />
        </Box>
      </Box>
      <Typography
        variant="caption"
        sx={{
          display: "block",
          px: 1,
          py: 0.75,
          color: "white",
          whiteSpace: "nowrap",
          fontFamily: "Inter, sans-serif",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {item.caption}
      </Typography>
    </Box>
  );
};

const VideoThumbsList = ({ items = [] }) => {
  const popupRef = useRef(null);
  const [activeTab, setActiveTab] = useState("all");

  const filteredItems = activeTab === "all"
    ? items
    : items.filter((item) => item.type === activeTab);

  const handlePlay = (videoUrl) => {
    popupRef.current?.showURL(videoUrl);
  };

  return (
    <>
      <Tabs
        value={activeTab}
        onChange={(_, val) => setActiveTab(val)}
        textColor="inherit"
        TabIndicatorProps={{ style: { backgroundColor: "rgb(0, 229, 255)" } }}
        sx={{
          minHeight: 36,
          px: 1,
          "& .MuiTab-root": {
            color: "rgb(200, 200, 200)",
            minHeight: 36,
            py: 0.5,
            fontFamily: "Noto Sans TC, sans-serif",
            fontSize: "12px",
            fontWeight: 900,
            textShadow: "0 0 8px rgba(0, 229, 255, 0.6)",
            textTransform: "none",
          },
          "& .Mui-selected": { color: "#00E5FF" },
        }}
      >
        {TAB_FILTERS.map((tab) => (
          <Tab key={tab.value} value={tab.value} label={tab.label} />
        ))}
      </Tabs>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
          overflowX: "auto",
          overflowY: "hidden",
          py: 1,
          px: 0.5,
          scrollbarWidth: "thin",
          scrollbarColor: "rgba(255,255,255,0.3) transparent",
          "&::-webkit-scrollbar": { height: 6 },
          "&::-webkit-scrollbar-thumb": {
            bgcolor: "rgba(255,255,255,0.3)",
            borderRadius: 3,
          },
          "&::-webkit-scrollbar-track": { bgcolor: "transparent" },
        }}
      >
        {filteredItems.map((item, index) => (
          <VideoThumbCard key={index} item={item} onPlay={handlePlay} />
        ))}
      </Box>

      <FullscreenVideoPopup ref={popupRef} />
    </>
  );
};

export default VideoThumbsList;
